import React from 'react';
import { Col, FormControl, Panel, HelpBlock } from 'react-bootstrap';
// src
import { NEW_ORDER_PATH as path } from '../../../routes/routes_production.js';
import { PostRequest } from '../../../api/PostRequest.js';
// css
import '../styles/ordersStyles.css';

class PanelPrenotazione extends React.Component {
	constructor(props) {
		super(props);  

		this.state = {			
			nrPrenotazione: null,
			nrSerata: null,
			dataSerata: null,
      editMode: (this.props.editMode)? true : null
		}

		this.checkNrPrenotazione = this.checkNrPrenotazione.bind(this);			
    this.handleInvalidField = this.handleInvalidField.bind(this);
    this.handleValidField = this.handleValidField.bind(this);
		this.validateOnChange = this.validateOnChange.bind(this);
    this.generateMessage = this.generateMessage.bind(this);
	}

  render() { 	
  	const { nrPrenotazione, nrSerata, dataSerata, editMode } = this.state;
  	return (
  		<Col xs={12} className="mt-2">
		    <Panel>		      
		      <Panel.Heading>Prenotazione</Panel.Heading>
		      <Panel.Body>     

		        <Col xs={12} lg={4}>
		          <label htmlFor="nrPrenotazione">Nr. prenotazione</label>
		          <FormControl 
		            id="nrPrenotazione" name="nrPrenotazione"	type="text"	            		            	 
                data-caption="Nr. prenotazione"              	     		            
		            pattern="^[0-9]*[1-9][0-9]*$" maxLength="11" 
                onChange={this.checkNrPrenotazione}
                required autoComplete="off"
                defaultValue={editMode? this.props.panPrenotazione['nrPrenotazione'] : ''}
                data-separator="%%%Prenotazione"
		          />
		          <HelpBlock className="colorRed">{nrPrenotazione}</HelpBlock>
		        </Col>

		        <Col xs={12} lg={4}>
		          <label htmlFor="nrSerata">Nr. serata</label>
		          <FormControl 
		            id="nrSerata" name="nrSerata"	type="text"	            
		            onChange={this.validateOnChange}	            
		            pattern="^[0-9]*[1-9][0-9]*$" maxLength="255" required autoComplete="off"
                data-caption="Nr. serata"
                defaultValue={editMode? this.props.panPrenotazione['nrSerata'] : ''}
		          />
		          <HelpBlock className="colorRed">{nrSerata}</HelpBlock>
		        </Col>

		        <Col xs={12} lg={4}>
		          <label htmlFor="dataSerata">Data della serata</label>
		          <FormControl 
		            id="dataSerata" name="dataSerata" type="text" 
                placeholder="GG/MM/AAAA" onChange={this.validateOnChange} 		            		            		            
		            pattern="\d{2}\/\d{2}/\d{4}" required autoComplete="off"
                data-caption="Data della serata" data-parse="date"
                maxLength="10"
                defaultValue={editMode? this.props.panPrenotazione['dataSerata'] : ''}
		          />
		          <HelpBlock className="colorRed">{dataSerata}</HelpBlock>
		        </Col>
		      </Panel.Body>
		    </Panel>
		  </Col>
  	);
  }  

  // Controlla che il numero di prenotazione
  // non sia già stato utilizzato per un altro ordine,
  // ritorna appropriati feedback visivi e gestisce il submit
  checkNrPrenotazione(e) {    
  	const field = e.target;

    if(this.state.editMode) {      
      e.target.value = this.props.panPrenotazione['nrPrenotazione'];      
      return;
    }

    const pattern = e.target.pattern;
  	const bookingNumber = field.value;  	 	
    
  	if(!bookingNumber.match(pattern)) {  	
  		this.handleInvalidField(field, 'Inserisci un numero positivo');
  		return;
  	}

  	const params = {
  		'request' : 'checkNrPrenotazione',
  		'bookingNumber' : bookingNumber  		
  	};

  	PostRequest(path, params) 
      .then((res) => {  
      	// Numero di prenotazione utilizzabile  
      	if(res[0] === "response" && res[1] === "false") {     		  		      		
      		this.handleValidField(field);  		      		
      	} else {
      	  this.handleInvalidField(field, "Numero della prenotazione già in uso");      	    	
        }
      })
      .catch((err) => { 
        console.log(err);          
      });   
  }

  // Gestisce il mancato superamento della validazione
  handleInvalidField(field, errorMessage) {    
    // invalida il form (non permette il submit)
    field.setCustomValidity(errorMessage); 
    // cambia il colore dei bordi del campo
    field.classList.add('invalid-field'); 
    // mostra il messaggio di warning a video
    this.setState({[field.name] : [errorMessage]}); 
  }

  // Gestisce il superamento della validazione
  handleValidField(field) {
    let style = 'invalid-field';
    // Invalida il form (non permette il submit)
    field.setCustomValidity(''); 
    // Cambia il colore dei bordi del campo    
    if(field.classList.contains(style))
      field.classList.remove(style); 
    // Pulisce il messaggio di warning a video
    this.setState({[field.name] : ''});  
  }

  // Valida il campo e richiama il feedback appropriato
  validateOnChange(e) {        
    const field = e.target;
    const pattern = e.target.pattern;           
    // field.dataset.parse corrisponde all'attributo HTML5 data-parse       
    const message = this.generateMessage(field.dataset.parse);   

		if(!field.value.match(pattern)) {
			this.handleInvalidField(field, message);
		} else {
      this.handleValidField(field);
    }
  }

  // Ritorna un messaggio di errore in base al tipo del campo
  // che non ha superato la validazione del formato
  generateMessage(fieldType) {
    switch(fieldType) {
      case "number": 
        return 'Inserisci un numero positivo';        
      case "date": 
        return 'Inserisci il formato GG/MM/AAAA';       
      default:
        return null;
    }
  }
}

export default PanelPrenotazione;


// WEBPACK FOOTER //
// ./src/cmp/Orders/Panels/PanelPrenotazione.js